
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/archive/lps",
      function () {
        return require("private-next-pages/archive/lps.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/archive/lps"])
      });
    }
  